import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = "/api";

export const WaitlistForm = ({ id = "main", compact = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email });
      setDone(true);
      toast.success(data.message, {
        description: `Total ${data.count} trader sudah antre untuk akses V1.`,
      });
    } catch (err) {
      toast.error("Gagal mendaftar", {
        description: err.response?.data?.detail?.[0]?.msg || "Periksa kembali email Anda.",
      });
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid={`waitlist-success-${id}`}
        className="border border-buy/40 bg-buy/5 px-5 py-4 font-mono text-sm text-buy"
      >
        &gt; TERDAFTAR — Anda masuk antrean akses awal V1.
        <span className="blink-cursor ml-1">▌</span>
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid={`waitlist-form-${id}`}
      className={`flex w-full ${compact ? "max-w-md" : "max-w-xl"} flex-col gap-3 sm:flex-row`}
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="email@anda.com"
        data-testid={`waitlist-email-input-${id}`}
        className="h-12 flex-1 border border-white/15 bg-ink-surface px-4 font-mono text-sm text-white placeholder:text-mute-dim outline-none transition-colors duration-300 focus:border-buy/60"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid={`waitlist-submit-${id}`}
        className="group relative h-12 overflow-hidden border border-buy bg-buy/10 px-6 font-mono text-sm font-bold uppercase tracking-wider text-buy transition-colors duration-300 hover:text-ink disabled:opacity-60"
      >
        <span className="absolute inset-0 -translate-x-full bg-buy transition-transform duration-300 ease-out group-hover:translate-x-0" />
        <span className="relative flex items-center gap-2">
          {loading ? <Loader2 size={16} className="animate-spin" /> : <ArrowRight size={16} />}
          Gabung Waitlist
        </span>
      </button>
    </form>
  );
};
